import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import UseBase from '../Hooks/UseBase';
import CardSlider from './CardSlider';

const MovieDetail = () => {
  const { instance } = UseBase();
  let { id } = useParams();
  const [movies, setMovies] = useState([]);
  // console.log(id);
  const {
    original_title,
    genres,
    release_date,
    spoken_languages,
    poster_path,
    backdrop_path,
    overview,
  } = movies;
  // https://cineplex-web-api.cineplexbd.com/api/v1/movie/234/detail
  useEffect(() => {
    instance
      .get(`/${id}?api_key=0bdaffe7e2eab547e56a8fb25f90ff20&language=en-US`)
      .then(function (response) {
        setMovies(response?.data);
        // console.log(response?.data);
      });
  }, [id]);

  useEffect(() => {
    axios.post(
      `https://cineplex-web-api.cineplexbd.com/api/v1/movie/234/detail`
    );
  }, []);

  const imageUrl = `https://www.themoviedb.org/t/p/w1920_and_h800_multi_faces/${backdrop_path}`;

  return (
    <>
      <div className='relative'>
        <img
          src={imageUrl}
          alt=''
          className='absolute inset-0 w-full h-full object-cover filter blur-md'
        />
        <div className='relative z-10 p-10'>
          <div className=' filter grid xl:grid-cols-4 gap-4 container mx-auto z-100  py-10   z-100'>
            <div className='xl:col-span-1  '>
              <img
                className='rounded-2xl '
                src={`https://www.themoviedb.org/t/p/w300_and_h450_bestv2/${poster_path}`}
                alt=''
              />
            </div>

            <div className='xl:col-span-3  content-center grid text-left text-black '>
              <h2 className='font-semibold text-2xl '>{original_title} </h2>
              <ul className='text-sm'>
                <li className=''>
                  Category: {genres?.map((item) => `${item?.name}, `)}{' '}
                </li>
                <li>Actor:</li>
                {/* <li>
                Genre:
                {genres.map((genre) => (
                  <span>{genre.name}</span>
                ))}
              </li> */}
                <li>Release : {release_date} </li>
                {/* <li>
                Language : {spoken_languages.map((language) => language.name)}
              </li> */}
              </ul>

              <h4 className='font-semibold text-xl py-2'>Overview </h4>
              <p className='text-sm'> {overview}</p>
            </div>
          </div>
        </div>
      </div>
      <CardSlider />
    </>
  );
};

export default MovieDetail;
